import { Typography, Grid } from "@material-ui/core";
import clsx from "clsx";
import { emptyDetailsStyles } from "./empty-details-state.styles";

interface EmptyDetailsStateProps {
  className?: string;
  title: string;
  imageUrl: string;
  description: string;
  action: JSX.Element;
  direction?: "row" | "column";
}

export const EmptyDetailsState = (props: EmptyDetailsStateProps) => {
  const { action, imageUrl, description, title, direction, className } = props;
  const classes = emptyDetailsStyles();

  return (
    <div
      className={clsx(classes.container, className)}
      id="container"
      data-testid="container"
    >
      <Grid
        container
        data-testid="empty-details-state"
        className="details-state"
        direction={direction}
        justifyContent={direction ? "center" : "flex-start"}
        alignContent={direction ? "center" : "flex-start"}
        id="#highlight-1"
      >
        <Grid
          item
          lg={4}
          md={4}
          sm={12}
          xs={12}
          className={classes.imageContainer}
          id="imageContainer"
          data-testid="imageContainer"
        >
          <img alt="connect-account" src={imageUrl} />
        </Grid>
        <Grid container item lg={8} md={8} sm={12} xs={12} alignItems="center">
          <Grid container>
            <Grid item xs={12}>
              <Typography
                variant="h6"
                className={classes.title}
                data-testid="title"
                id="title"
              >
                {title}
              </Typography>
            </Grid>

            <Grid item sm={12} xs={12}>
              <Typography
                variant="body1"
                className={classes.description}
                data-testid="description"
                id="description"
              >
                {description}
              </Typography>
            </Grid>
            <Grid item sm={12} xs={12} id="action" data-testid="action">
              {action}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

EmptyDetailsState.defaultProps = {
  direction: "row",
};
